import { Link } from "react-router-dom";
// SVGS
import Lock from "../../../SVGS/Lock";
// styles
import { NavLinkStyles } from "./navLink.styles";

const NavLink = ({ isActive, path, Icon, name, onClick, locked }) => {
  return (
    <Link style={{ textDecoration: "none" }} to={path} onClick={onClick}>
      <NavLinkStyles $isActive={isActive}>
        <Icon />
        <p className="linkName">{name}</p>
        {/* Not on this plan — the page itself shows the upsell. */}
        {locked && (
          <span className="lockIco" title="Not included in your plan">
            <Lock width="13" height="13" />
          </span>
        )}
      </NavLinkStyles>
    </Link>
  );
};

export default NavLink;
